import { useScrollTo as useScrollToHook } from './useScrollTo.ts';
import { useScrollToQueryParameter as useQueryParameter } from './useScrollToQueryParameter.ts';

export enum ScrollTo {
  Bid = 'Bid',
}

export const useScrollTo = useScrollToHook;

export const useScrollToQueryParameter = useQueryParameter;
